import { styled } from '@mui/material/styles';

export const HeaderSectionContainer = styled('div')(({ theme }) => ({
  padding: 24,
  gap: 32,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  // `divider` (#EAF0F1) is the app-wide separator rule. This used grey[70] (#85A2A6) —
  // four steps darker on the neutral ramp, which read as a hard rule rather than a divider.
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
